import { render, staticRenderFns } from "./SwappTasksLibrary.vue?vue&type=template&id=40df53e5&scoped=true"
import script from "./SwappTasksLibrary.vue?vue&type=script&lang=js"
export * from "./SwappTasksLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df53e5",
  null
  
)

export default component.exports